<div class="website-builder-container">
  <!-- Content Area -->
    <div class="content-area">
      <!-- Page Header -->
      <div class="page-header">
        <div class="header-content">
          <h1 class="page-title">{{ existingWebsite ? 'Manage Your Website' : "Let's start creating your website!" }}</h1>
          <p class="page-description">{{ existingWebsite ? 'Update your branding, pages, and SEO. Changes are saved as drafts until published. You may switch to a new template at any time.' : 'Choose a design for your car wash site.' }}</p>
        </div>
      </div>
      
      <!-- Tab Navigation -->
      <div class="tab-navigation">
        <button 
          *ngIf="existingWebsite"
          class="tab-button"
          [class.active]="activeTab === 'your-website'"
          (click)="setActiveTab('your-website')">
          Your Website
        </button>
        <button 
          class="tab-button"
          [class.active]="activeTab === 'browse-templates'"
          (click)="setActiveTab('browse-templates')">
          Browse Templates
        </button>
      </div>
      
      <!-- Templates / Existing Website Container -->
      <div class="templates-container">
        <!-- Shimmer Loading State - Your Website Tab -->
        <div *ngIf="activeTab === 'your-website' && loadingWebsite" class="your-website-section">
          <div class="website-panel shimmer-panel">
            <!-- Preview Thumbnail Shimmer -->
            <div class="website-thumbnail shimmer-thumbnail">
              <div class="shimmer-box"></div>
            </div>
            
            <!-- Website Content Shimmer -->
            <div class="website-content">
              <div class="website-info">
                <div class="status-row">
                  <div class="shimmer-badge shimmer-box"></div>
                  <div class="shimmer-text shimmer-box w-150"></div>
                </div>
                <div class="shimmer-title shimmer-box w-200"></div>
                <div class="website-actions-bottom">
                  <div class="shimmer-button shimmer-box w-120"></div>
                </div>
              </div>
              
              <!-- Top Right Menu Shimmer -->
              <div class="website-actions-top">
                <div class="shimmer-menu shimmer-box w-32"></div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Existing Website card - Your Website Tab -->
        <div *ngIf="activeTab === 'your-website' && existingWebsite && !loadingWebsite" class="your-website-section" (click)="closeMenuOnOutsideClick($event)">
          <div class="website-panel">
            <!-- Preview Thumbnail -->
            <div class="website-thumbnail">
              <img [src]="existingWebsite?.thumbnail || existingWebsite?.thumbnail_url || 'assets/images/website-preview-placeholder.svg'" 
                   alt="Website preview">
            </div>
            
            <!-- Website Content -->
            <div class="website-content">
              <div class="website-info">
                <div class="status-row">
                  <span class="status-badge"
                        [class.draft-badge]="!isWebsitePublished"
                        [class.published-badge]="isWebsitePublished">
                    {{ isWebsitePublished ? 'Published' : 'Draft' }}
                  </span>
                  <span class="update-status">Update Status: {{ existingWebsite?.updated_at | date:'MMM d, yyyy' }}</span>
                </div>
                <h3 class="website-name">{{ existingWebsite?.name || 'Way - Car Wash and Detailing Service' }}</h3>
                <div class="website-actions-bottom">
                  <button class="btn-edit-website" (click)="onEditExisting()">Edit Website</button>
                </div>
              </div>
              
              <!-- Top Right Menu -->
              <div class="website-actions-top">
                <button class="btn-menu" (click)="toggleMenu()" [class.active]="showMenu">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="3" r="1.5" fill="currentColor"/>
                    <circle cx="8" cy="8" r="1.5" fill="currentColor"/>
                    <circle cx="8" cy="13" r="1.5" fill="currentColor"/>
                  </svg>
                </button>
                
                <!-- Dropdown Menu -->
                <div class="dropdown-menu" *ngIf="showMenu">
                  <button class="dropdown-item" (click)="onReset()">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C9.29395 2 10.4935 2.41211 11.4785 3.10742" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                      <path d="M11 1V4H14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Reset Confirmation Modal -->
        <div class="modal-overlay" *ngIf="showResetModal" (click)="closeResetModal()">
          <div class="modal-content" (click)="$event.stopPropagation()">
            <div class="modal-header">
              <h3 class="modal-title">Reset Website?</h3>
              <button class="modal-close" (click)="closeResetModal()">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
            <div class="modal-body">
              <p class="modal-description">
                Are you sure you want to reset your website? This will revert all changes to the last published version. Any unpublished changes will be lost.
              </p>
              
              <div class="divider"></div>
              
              <div class="confirmation-radio">
                <label class="radio-label">
                  <input 
                    type="checkbox" 
                    [(ngModel)]="resetConfirmed" 
                    class="radio-input">
                  <span class="radio-custom"></span>
                  <span class="radio-text">I understand this action cannot be undone</span>
                </label>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn-cancel" (click)="closeResetModal()" [disabled]="resettingWebsite">Cancel</button>
              <button 
                class="btn-confirm-reset" 
                [disabled]="!resetConfirmed || resettingWebsite"
                (click)="confirmReset()">
                <svg *ngIf="resettingWebsite" class="spinner" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 1.5V4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                  <path d="M8 11.5V14.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0.3"/>
                  <path d="M3.75 3.75L5.81 5.81" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0.9"/>
                  <path d="M10.19 10.19L12.25 12.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0.2"/>
                  <path d="M1.5 8H4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0.8"/>
                  <path d="M11.5 8H14.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0.4"/>
                  <path d="M3.75 12.25L5.81 10.19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0.7"/>
                  <path d="M10.19 5.81L12.25 3.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0.5"/>
                </svg>
                <span *ngIf="!resettingWebsite">Reset Website</span>
                <span *ngIf="resettingWebsite">Resetting...</span>
              </button>
            </div>
          </div>
        </div>
        
        <!-- Browse Templates Tab -->
        <div *ngIf="activeTab === 'browse-templates'">
          <!-- Loading State -->
          <div *ngIf="loading" class="loading-container">
            <div class="loading-spinner"></div>
            <p>Loading templates...</p>
          </div>

          <!-- Error State -->
          <div *ngIf="error && !loading" class="error-container">
            <div class="error-message">
              <h3>Oops! Something went wrong</h3>
              <p>{{ error }}</p>
              <button class="retry-button" (click)="loadTemplates()">Try Again</button>
            </div>
          </div>

          <!-- Templates Grid -->
          <div *ngIf="!loading && !error" class="templates-grid">
            <app-template-preview-card
              *ngFor="let template of templates; trackBy: trackById"
              [template]="template"
              [isLoading]="isTemplateLoading(template)"
              (templateSelect)="onTemplateSelect($event)"
              (templatePreview)="onTemplatePreview($event)">
            </app-template-preview-card>
          </div>
        </div>
      </div>
    </div>
</div>